// extracted by mini-css-extract-plugin
export var activityContainer = "_ir-0";
export var typingIndicatorContainer = "_ir-1";
export var typingIndicatorDot = "_ir-2";
export var wave = "_ir-3";